import React, { Component } from 'react';
import {
  WithStyles, createStyles, Grid, Typography, IconButton, Button
} from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
// import _ from 'lodash';
import { MyPatVideoPlayer } from '../../../../common';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress, { LinearProgressProps } from '@material-ui/core/LinearProgress';
import { videoActions } from '../../../reducers/videoCreateContentReducers';
import { VIDEO_UPLOAD_MODES } from '../../../../../constants/comman';

const styles = (theme: Theme) => createStyles({
  button: {
    margin: theme.spacing.unit,
  },
  progressBarContainer:{
    'border':'solid 1px #DFDFDF',
    padding:'18px',
    'border-radius':'8px',
    margin:'20px 0',
  },
  padRightNew:{
    paddingRight:'20px'
  },
  fontSize12:{
    fontSize:'12px'
  },
  ProgressBarwithLabel:{
    fontSize:'12px',
    height:'8px',
    borderRadius:'17px',
    color:'#666666',
  },
  uploadTextLabel:{
    fontSize:'12px',
    fontWeight:'normal',
    color:'#666666',
  },
});

interface VideoProgressBarProps extends WithStyles<typeof styles> {
  onDialogClose: Function;
  createVideoContent: Function;
  videoUploadProgressPercentage: any;
  videoURL: any;
  videoDetails: any;
  mode: string;
  deleteVideo: Function;
}

interface VideoProgressBarState {
  uri: any
}

function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
  return (
    <div >
      <div>
        <LinearProgress variant="buffer"   {...props} />
      </div>
      <div>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </div>
    </div>
  );
}

const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

const convertVideoSize = (length: any) => {
  let typeIndex = 0, number = parseInt(length, 10) || 0;
  while(number >= 1024 && ++typeIndex){
      number = number/1024;
  }
  return(number.toFixed(number < 10 && typeIndex > 0 ? 1 : 0) + ' ' + units[typeIndex]);
}


class VideoProgressBar extends Component<VideoProgressBarProps, VideoProgressBarState> {
  constructor(props: VideoProgressBarProps) {
    super(props);
    const { videoDetails } = props;
    this.state = {
      uri: window.URL.createObjectURL(videoDetails.file)
    }
  }

  cancelUpload = () => {
    const { videoDetails, videoURL, videoUploadProgressPercentage } = this.props;
    if (videoUploadProgressPercentage >= 100 && videoURL.length) {
      this.props.deleteVideo(videoURL);
    } else {
        videoDetails.source.cancel();
    }
}

  render() {
    const { classes, onDialogClose, createVideoContent, videoUploadProgressPercentage, videoURL = '', videoDetails, mode } = this.props;
    const { uri } = this.state;
    const totalVideoLength = convertVideoSize(parseInt(videoDetails.length));
    const uploadedVideoLength = convertVideoSize(parseInt(videoDetails.length, 10)*parseInt(videoUploadProgressPercentage, 10)/100);
    return (
      <>
      <div style={{alignContent:'center',}}>
        <Grid container className={classes.progressBarContainer}>
          <Grid item xs={3} className={classes.padRightNew}> 
          <video width="93px" height="62px" src={uri} />
          </Grid>
          <Grid item xs={8}>
            <Typography className={classes.fontSize12}>
              File Name
        </Typography>
            <LinearProgressWithLabel value={videoUploadProgressPercentage} className={classes.ProgressBarwithLabel}/>
            <div className={classes.uploadTextLabel}>
              {`${uploadedVideoLength} of ${totalVideoLength}`}
            </div>
          </Grid>
          <Grid item xs={1}>
            <IconButton aria-label="close" onClick={this.cancelUpload}>
            <img alt="Cancel video upload" src="/assets/svg/learn/videoUploadCancel.svg" />
            </IconButton>
          </Grid>
        </Grid>
        </div>
        
        <Grid container>
          <Grid item sm ></Grid>
         {mode=== VIDEO_UPLOAD_MODES.EDIT? '' : <Grid item>
            <Button
              className={classes.button}
              color="primary"
              onClick={() => onDialogClose()}
            >
              Cancel
						</Button>
          </Grid>}
          <Grid item>
            <Button
              disabled={videoUploadProgressPercentage < 100 || !videoURL.length}
              className={classes.button}
              variant="contained"
              color="primary"
              onClick={() => createVideoContent(videoURL)}
            >
              Submit
						</Button>
          </Grid>
        </Grid>
      </>
    )
  }
}

const mapStateToProps = (state: any) => {
  return {
    videoUploadProgressPercentage: state.videoCreateContent.videoUploadProgressPercentage,
    videoURL: state.videoCreateContent.videoURL,
    videoDetails: state.videoCreateContent.videoDetails
  }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(VideoProgressBar));